import styles from './InfoModal.module.css';

const InfoModal = ({
  isOpen,
  onClose,
  icon,
  title,
  content,
  actionText,
  onActionClick,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleAction = () => {
    if (onActionClick) {
      onActionClick();
    }
    onClose(); // Always close the modal after the action
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <div className={styles.modalHeader}>
          <i className={`${icon} ${styles.modalIcon}`}></i>
          <h3>{title}</h3>
        </div>
        <p className={styles.modalText}>{content}</p>
        <div className={styles.modalActions}>
          {actionText && onActionClick && (
            <button onClick={handleAction} className="action-button secondary">
              {actionText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
